import type { Product, ProductDto } from '@/Data/products';

const API_BASE = import.meta.env.VITE_API_URL;

// Helper: convert API → Frontend Product
function mapProductDto(p: ProductDto): Product {
  return {
    id: p.id,
    slug: `product-${p.id}`,
    name: p.name,
    description: p.description,
    price: p.price,
    isFeatured: p.isFeatured,

    thumbnails: p.thumbnails ?? [],
    mediaGallery: p.mediaGallery ?? [],
    features: p.features ?? [],

    productVideoUrl: p.productVideoUrl ?? null,
  };
}

// ======================================================
// FETCH ALL PRODUCTS (FULL)
// ======================================================
export async function fetchProducts(): Promise<Product[]> {
  const res = await fetch(`${API_BASE}/api/products/full`);
  if (!res.ok) throw new Error('Failed to load products');

  const data: ProductDto[] = await res.json();
  return data.map(mapProductDto);
}

// ======================================================
// FETCH SINGLE PRODUCT
// ======================================================
export async function fetchProductById(id: number): Promise<Product | null> {
  const res = await fetch(`${API_BASE}/api/products/${id}`);
  if (!res.ok) return null;

  const data: ProductDto = await res.json();
  return mapProductDto(data);
}
